export const ServerIp = process.env.REACT_APP_SERVER_IP;

// export const ServerIp = ' http://206.189.49.168';



// WEBPACK FOOTER //
// ./src/constants/env.js